import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FuseLoadingBarComponent } from '@fuse/components/loading-bar';
import { EmptyLayoutComponent } from 'app/fuse-template/layout/layouts/empty/empty.component';
import { SharedModule } from 'app/fuse-template/shared/shared.module';

@NgModule({
    declarations: [EmptyLayoutComponent],
    imports: [FuseLoadingBarComponent, RouterModule, SharedModule],
    exports: [EmptyLayoutComponent],
})
export class EmptyLayoutModule {}
